/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { Report } from '../../../../../model';
import { ReportDelayProvider } from '../../../../../providers';
import { ReportDelay } from '../../../../../model/report';
import { LogService } from 'src/app/services';

@Component({
  selector: 'edit-report-delay-modal',
  templateUrl: './edit-report-delay.modal.html',
  styleUrls: ['./edit-report-delay.modal.scss']
})
export class EditReportDelayModal implements OnInit, OnDestroy {
  subject: Subject<boolean>;
  subscription: any;

  currentReport: Report;
  delay: ReportDelay = new ReportDelay();
  isStart: boolean = null;

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private reportDelayProvider: ReportDelayProvider,
    private logService : LogService

  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc')
        this.onCancel();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  onConfirm(): void {
    this.reportDelayProvider.saveDelay(this.currentReport.ID, this.delay.ID, this.delay)
      .subscribe(data => {
        if(data.success){
          this.bsModalRef.hide();
          this.subject.next(true);
          this.subject.complete();
        }
        else {
          this.logService.error(JSON.stringify(data.result, null, 2));
        }
      });
  }


  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(null);
    this.subject.complete();
  }

  appendCannedAction(field: string, action: string): void {
    let newLine = false;
    if(this.delay[field]){
      if(this.delay[field].length > 0)
        newLine = true;
    }else this.delay[field] = '';

    switch (action) {
      case 'delayed':
        this.delay[field] += (newLine ? ' ' : '') + 'The Business Valuation has been delayed ';
        break;
      case 'no response':
        this.delay[field] += (newLine ? ' ' : '') + ' as the Financial Analyst has not received the responses to the Supplemental Questionnaire - Management Interview (via phone interview and/or email)';
        break;
      case 'real est':
        this.delay[field] += (newLine ? ' ' : '') + ' as it has been determined the business valuation will rely on a Real Estate Appraisal (pending receipt).';
        break;
      case 'equip appr':
        this.delay[field] += (newLine ? ' ' : '') + ' as the business valuation will be completed upon receipt of an Equipment Appraisal (pending receipt).';
        break;
    }
  }
}
